<template>
  <div class="my-20">
    <TransitionFade>
      <div class="flex flex-col justify-center items-center w-full">
        <div class="absolute top-5 right-5">
          <SelectLangs />
        </div>
        <div class="py-14 mx-auto z-10">
          <div class="w-full">
            <div class="text-center mb-6">
              <div class="inline-flex space-x-6">
                <svg class="w-60 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 285.76 99.82" fill="currentColor"> 
                  <path d="M270.57 14A13.77 13.77 0 0 0 257.26.19h-77.74L178 6.71h78.88A7.3 7.3 0 0 1 264 14a7.47 7.47 0 0 1-.26 1.84l-11.51 49.34a.75.75 0 0 1-.18.34 7.3 7.3 0 0 1-6.71 4.61h-75.08a2.69 2.69 0 0 0-1.77.65l-18.66 17.56 3.79-14.86a2.19 2.19 0 0 0 .11-.67 2.5 2.5 0 0 0-2.53-2.63h-137a7.31 7.31 0 0 1-7.29-7.3 5 5 0 0 1 .07-.78.66.66 0 0 1 0-.28l11.5-49.2a.54.54 0 0 1 .07-.19 7.24 7.24 0 0 1 6.65-5.56.53.53 0 0 1 .24-.06L127 6.79 128.59.2 25.39.23a7.32 7.32 0 0 0-1.24.1 13.71 13.71 0 0 0-11.88 10 6.25 6.25 0 0 0-.23.77L.55 60.29a7.89 7.89 0 0 0-.19 1.45v1.1a13.86 13.86 0 0 0 13.79 13.85h131.16l-4.23 17.38a7.05 7.05 0 0 0-.13 1 4.74 4.74 0 0 0 7.83 3.58l24.05-22 72.33.06h.71a13.94 13.94 0 0 0 11.95-8 7.36 7.36 0 0 0 .78-2l11.51-49.22a13.93 13.93 0 0 0 .45-3.42ZM285.45 6.29a5.86 5.86 0 0 1-.45 2.23 5.46 5.46 0 0 1-1.2 1.87 5.88 5.88 0 0 1-1.71 1.25 6 6 0 0 1-2.61.59 5.8 5.8 0 0 1-2.37-.48 5.9 5.9 0 0 1-1.83-1.21 6.43 6.43 0 0 1-1.16-1.62 6.13 6.13 0 0 1-.28-4.6 5.79 5.79 0 0 1 .84-1.6 6.76 6.76 0 0 1 1.22-1.23 5.8 5.8 0 0 1 1.66-.86 6.32 6.32 0 0 1 1.94-.31 5.87 5.87 0 0 1 2.57.59 5.55 5.55 0 0 1 1.71 1.22 6.25 6.25 0 0 1 1.12 1.63 5.88 5.88 0 0 1 .55 2.53m-5.95-5a4.86 4.86 0 0 0-2.08.47 5.3 5.3 0 0 0-1.33.94A5.05 5.05 0 0 0 275 4.25a4.53 4.53 0 0 0-.44 2 5 5 0 0 0 .66 2.46 4.62 4.62 0 0 0 1.81 1.83 4.84 4.84 0 0 0 4.88 0 4.62 4.62 0 0 0 1.81-1.83 5 5 0 0 0 .66-2.46 4.72 4.72 0 0 0-.21-1.41 5 5 0 0 0-.6-1.29 5.33 5.33 0 0 0-1-1.16 4.89 4.89 0 0 0-1.44-.81 4.8 4.8 0 0 0-1.61-.29m-.88 8.26h-1.7V3h2.76a3 3 0 0 1 2 .54 1.67 1.67 0 0 1 .64 1.35 1.69 1.69 0 0 1-.43 1.2 1.71 1.71 0 0 1-1.18.49 2 2 0 0 1 .84.32 1.31 1.31 0 0 1 .51.63 2.33 2.33 0 0 1 .16.9V9a1.85 1.85 0 0 0 .11.58h-1.64a4.37 4.37 0 0 1-.11-1 1.92 1.92 0 0 0-.15-.8.9.9 0 0 0-.42-.37 2.83 2.83 0 0 0-1-.12h-.36v2.3Zm0-3.52h.67a1.4 1.4 0 0 0 1-.28.9.9 0 0 0 .3-.71.82.82 0 0 0-.42-.76 1.91 1.91 0 0 0-.9-.17h-.63v1.96Z" fill="currentColor"></path><path d="m185.4 62.31 1.41-5.84h-.17c-2.15 3.65-6.95 7.38-11.2 7.38-7.8 0-11.19-3.57-9.64-10l9.38-39h13.49l-8.17 34c-.36 2.2-.23 4.15 2.35 4a5 5 0 0 0 4.86-4l8.18-34h13.49L198 62.31ZM228.82 14.8l-1.39 5.76h.17c3.77-4.75 8-6.95 12.75-7.13 8.91 0 9.42 8.83 7.62 16.3L244 46.2c-1.94 8.06-6.12 17.31-16 17.65-2.4.08-6.38-1.36-8.4-6h-.17L215.29 73H201.8l14.46-58.2Zm5.05 17.48c.67-2.8 1.87-7.81-2-7.81-3.65 0-5.33 3.82-6.44 8.4l-2.68 11.2c-1 4.08-1.28 8.83 2.05 8.74 4.33 0 5.41-5.17 6.14-8.23l3-12.3ZM43.2 14.8l-1.32 5.51h.17a17.06 17.06 0 0 1 11.75-6.88c4.38-.25 7.93 2.3 8.5 6.29h.17C66 15.47 70 13.43 73.82 13.43c6.37 0 11.22 3.48 9.67 9.93l-9.36 39H60.64l8.15-33.94c.37-2.21 0-4.07-2.62-3.9a4.62 4.62 0 0 0-4.59 3.9l-8.15 33.89h-13.5l8.15-33.94c.07-2 0-3.9-2.28-3.9-2.71 0-4.14 1.36-4.93 3.9l-8.15 33.94h-13.5L30.64 14.8ZM103.84 58.07c-4.29 3.74-7.67 5.78-13 5.78-7.64 0-11.15-5.18-9.33-12.73C84.08 40.34 90.75 37 97.16 35s12.32-2.55 13.55-7.64c.63-2.62-.35-4.91-3.07-4.91-4.92 0-5.73 3.39-6.94 7.38H87.2c2.26-11.89 11.32-16.39 22.18-16.39 13.33 0 17.18 4.08 14.68 14.52l-7 29.11a15.26 15.26 0 0 0-.16 5.25h-13.15l.09-4.24Zm4-18.84c-3.06 1.45-5.62 2.21-7.62 3.49a9.22 9.22 0 0 0-4.61 6.11c-.72 3 .56 5.09 3.78 5.09 4 0 5.84-4.16 6.66-7.21l1.79-7.48ZM122.25 62.31l11.42-47.51h13.5l-11.43 47.51Zm12.54-52.18L137.19 0h13.49l-2.4 10.09ZM142.87 62.31 157.77.04h13.5l-14.91 62.27h-13.49zM10.51 99.7h5.56c3.85 0 5.59-2.17 6.11-4.69.48-2.13-.41-3.47-2.15-3.72v-.05a4.39 4.39 0 0 0 3.23-3.5c.66-3.07-1.05-4-3.75-4H14l-3.48 16Zm6.25-13.64H18c1.63 0 2.27.56 1.92 2.09s-1.28 2.11-3.09 2.11h-.93l.91-4.2Zm-1.4 6.44h1.42c1.45 0 2.41.54 2 2.4a2.81 2.81 0 0 1-3.16 2.43h-1.28l1-4.83Zm11.36-8.81-3.48 16h9.36l.57-2.64h-6.06l.94-4.31h5.49l.57-2.65h-5.49l.82-3.77h5.84l.57-2.64ZM46 86.06h1.56c1.49 0 2.13.74 1.81 2.22a2.74 2.74 0 0 1-3 2.41H45l1-4.63ZM39.74 99.7H43l1.46-6.77h1.77c1.32 0 1.74.76 1.51 2L47.2 98a2.78 2.78 0 0 0 0 1.68h3.57v-.13c-.55-.32-.43-1.19-.11-2.87.71-3.39.62-4.6-1.56-4.89 1.95-.38 3.11-1.81 3.59-4 .6-2.74-.75-4.12-3.45-4.12h-6.02l-3.48 16ZM56 83.69l-3.48 16h9.36l.57-2.64h-6.11l.94-4.31h5.49l.57-2.65h-5.49l.82-3.77h5.84l.57-2.64Zm16.66 16 .57-2.64h-5.88l2.9-13.37H67l-3.48 16Zm5-16-3.48 16h9.36l.46-2.63h-6l.93-4.31h5.5L85 90.1h-5.54l.82-3.77h5.84l.57-2.64Zm9.93 0 .28 16H92l7.23-16h-3.4l-5 11.84h-.07L91 83.69ZM95 99.7h3.43l1.49-3.39h4.35v3.39h3.43l-.84-16h-4.08L95 99.7Zm9.2-13.23v7.2H101l3.14-7.2Zm8.15-2.78-3.48 16h3l2.43-11.21L116 99.7h3.75l3.48-16h-3l-2.38 11-1.6-11Zm12.27 0-.62 2.64h3.57l-2.88 13.37H128l2.9-13.37h3.57l.57-2.64Z" fill="currentColor"></path> 
                </svg>
                <div class="flex items-center" v-if="showPoweredBySetUp">
                  <div class="inline-flex items-center space-x-2 px-4 py-2 rounded-lg bg-white shadow-md poweredby">
                    <div class="text-sm font-semibold">{{ $t("mailupView.powered") }}</div>
                    <Brand size="small" />
                  </div>
                </div>
              </div>
            </div>
            <div v-if="multiAccount" class="hidden bg-white max-w-sm sm:rounded-lg mt-3 py-5 shadow-xl lg:block absolute ml-2 xl:ml-0 lg:left-3/4 xl:left-3/4 2xl:left-2/3">
              <ul class="flex md:flex-col md:justify-center gap-2 px-2">
                <h3 class="w-full px-2 text-gray-700 font-semibold leading-tight">{{ $t("mailupView.projects") }}</h3>
                <div v-for="account in accounts" :key="account.id">
                  <div class="flex px-2 py-2 w-full text-center md:text-left transition-all duration-300 text-gray-600 font-semibold cursor-pointer rounded-lg hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" :class="[account.tenant.id == accountSelect.tenant.id ? 'bg-gray-100' : '']">
                    <div class="flex flex-row justify-start items-center w-full">
                      <p @click="changeAccount(account)" class="text-gray-500 text-xs">{{ account.tenant.name }} (#{{ account.tenant.id }})</p>
                    </div>
                  </div>
                </div>
              </ul>
            </div>
            <div :class="['flex flex-col w-full mx-auto sm:rounded-lg shadow-xl md:max-w-lg bg-white mt-3 divide-y divide-dashed', shouldShowMapper ? 'md:max-w-6xl' : 'md:max-w-lg']">
              <div class="pt-8 py-4 px-6 md:px-8 space-y-4">
                <div class="w-full flex items-center py-2">
                  <h3 class="text-gray-600 font-semibold leading-tight">
                    {{ $t("mailupView.dashboard") }}
                    <span class="underline font-semibold text-gray-700">
                      {{ accountSelect.tenant.name }} <span v-if="multiAccount">(#{{ accountSelect.tenant.id }})</span>
                    </span>
                  </h3>
                </div>
                <p class="text-gray-500 text-sm py-2">{{ $t("mailupView.statusInfo") }}</p>
                <div class="w-full flex items-center pb-2">
                  <a href="https://login.mailup.com" target="_blank" class="flex items-center w-full justify-center text-gray-600 hover:text-gray-700 rounded-lg shadow-md hover:bg-gray-50 border border-gray-200 transition relative hover:border-gray-300 focus:border-gray-300 focus:ring-gray-300 focus:outline-none focus:ring">
                    <div class="w-4/12 lg:w-5/12 flex flex-row justify-evenly items-center">
                      <img src="https://setup.baymark.net/storage/channels/images/channel_2_short.png" alt="mailup" class="h-6 w-6" />
                      <span class="px-0 py-3 flex-1 text-center font-semibold">{{ $t("mailupView.goMailup") }}</span>
                    </div>
                  </a>
                </div>
              </div>
              <div>
                <div class="w-full flex flex-col justify-center items-center py-10" v-if="loading">
                  <Spinner color="blue" size="small" />
                </div>
                <div v-if="shouldShowMapper">
                  <div class="my-6 px-4">
                    <div v-if="editCredential">
                      <FormConnection :project="project" :channel="channelTo" :projectCredential="projectCredentialTo" :hiddenInputWithValue="true" />
                    </div>
                    <AutoMapper v-if="channelFrom.services && channelTo.services_output" :projectCredentialFromId="projectCredentialFrom.id" :projectCredentialToId="projectCredentialTo.id" :servicesFrom="channelFrom.services" :serviceTo="channelTo.services_output[0]" :integrations="project_connection.integrations ?? []" :channelFrom="channelFrom" :channelTo="channelTo" @dataFinish="finishIntegration" ref="automapper" />
                    <div class="flex items-center justify-end my-4">
                      <button class="btn btn-primary btn-xs" @click="completeIntegration">{{ $t("mailupView.saveChanges") }}</button>
                    </div>
                  </div>
                </div>
                <div v-if="shouldShowIntegration && !loading">
                  <div v-if="!project_connection.is_active" class="w-full flex flex-col justify-center items-start mt-4 ml-7">
                    <Button :label="$t('mailupView.reactive')" v-tooltip="$t('mailupView.reactiveMessage')" type="button" class="p-button-light shadow" @click="reactiveIntegrations()" />
                  </div>
                  <div class="w-full flex flex-col justify-center items-start py-4">
                    <div v-for="integration in project_connection.integrations" :key="integration.id">
                      <div class="flex items-center px-7 py-4">
                        <div class="flex-1 flex items-center">
                          <div class="space-x-2 flex items-center">
                            <CheckCircleIcon class="mr-1.5 h-5 w-5 text-green-400" aria-hidden="true" />
                            <div class="items-center flex">
                              <h2 class="text-sm font-semibold text-gray-800">{{ integration.service.name }}</h2>
                            </div>
                            <div v-if="integration.sync_at" class="hidden md:block col-span-1">
                              <p class="text-xs text-gray-900">({{ $moment(integration.sync_at).format("YYYY-MM-DD HH:mm") }} {{ $t("mailupView.lastUpdated") }})</p>
                            </div>
                            <button v-show="showCopyButton && integration.service.name == 'Products'" @click="copyButton" title="Copy to clipboard" class="inline-flex justify-center items-center text-xs text-gray-500 dark:text-gray-300 hover:bg-gray-100 p-1 focus:border-gray-300 focus:ring-gray-200 focus:outline-none focus:ring rounded-md transition-opacity">
                              <TransitionFade>
                                <ClipboardCopyIcon class="h-5 w-5" aria-hidden="true" />
                              </TransitionFade>
                              <span class="ml-1.5">{{ !copyAction ? $t("mailup.copy") : $t("mailup.copied") }}</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="flex flex-row justify-center w-full mb-4">
                      <Button :label="$t('mailup.editIntegrations')" type="button" class="p-button-light shadow" @click="enableEdit" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </TransitionFade>
  </div>
</template>

<script>
import TransitionFade from "@/components/TransitionFade"
import SelectLangs from "@/components/SelectLangs"
import Brand from "@/components/Brand"
import axiosClient from "@/config/AxiosClient"
import Spinner from "@/components/UI/Spinner"
import { CheckCircleIcon } from "@heroicons/vue/solid"
import { ClipboardCopyIcon } from "@heroicons/vue/outline"
import AutoMapper from "@/components/WizardNew/AutoMapper"
import FormConnection from "@/components/ChannelConnections/FormConnection"
import Button from "primevue/button"

export default {
  name: "DashboardMailup",
  components: {
    SelectLangs,
    Brand,
    Spinner,
    TransitionFade,
    CheckCircleIcon,
    ClipboardCopyIcon,
    AutoMapper,
    FormConnection,
    Button
  },
  data: function () {
    return {
      showPoweredBySetUp: false,
      driver: localStorage.getItem("driver"),
      account_uuid: localStorage.getItem("account_uuid"),
      accounts: JSON.parse(localStorage.getItem("account")),
      accountSelect: {},
      project_connection: {},
      multiAccount: false,
      completeIntegrations: false,
      loading: true,
      showCopyButton: false,
      copyAction: false,
      errors: {
        text: ""
      },
      channelFrom: {},
      channelTo: {},
      projectCredentialFrom: {},
      projectCredentialTo: {},
      project: {},
      editCredential: true,
      project_connection_id: null
    }
  },
  computed: {
    shouldShowMapper() {
      return (this.completeIntegrations == true || (this.project_connection.integrations && this.project_connection.integrations.length == 0)) && !this.loading
    },
    shouldShowIntegration() {
      return this.project_connection.integrations && this.project_connection.integrations.length && !this.completeIntegrations
    }
  },
  methods: {
    async getIntegration() {
      this.loading = true

      let response = await axiosClient.get(`/api/2.0/account/integrations/${this.accountSelect.uuid}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Token")}`
        } 
      })
      this.project_connection = response.data
      if (this.project_connection && (!this.project_connection.integrations || this.project_connection.integrations.length == 0)) {
        await this.createIntegration()
      } else {
        this.loading = false
      }

      if (this.project_connection.integrations.find((f) => f.service.name == "Products")) {
        this.showCopyButton = true
      }
    },
    changeAccount(accountSelect) {
      this.accountSelect = accountSelect
      this.getIntegration()
    },
    async createIntegration() {
      this.loading = true
      let response = await axiosClient.post(`/api/2.0/account/create/integration/onclick/${this.account_uuid}`, {}, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Token")}`
        } 
      })
      if (!response.data.channelFrom) {
        this.project_connection = response.data
        this.editCredential = false
      } else {
        this.channelFrom = response.data.channelFrom
        this.channelTo = response.data.channelTo
        this.projectCredentialFrom = response.data.project_credential_from
        this.projectCredentialTo = response.data.project_credential_to
        this.project = response.data.project
        this.project_connection_id = response.data.project_connection_id
        this.completeIntegrations = true
        this.editCredential = true
      }
      this.loading = false
    },
    async finishIntegration(data) {
      this.loading = true
      let response = await axiosClient.post(`/api/2.0/account/finish/integration/${this.account_uuid}`, { integrations: data, project_connection_id: this.project_connection_id }, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Token")}`
        } 
      })
      this.project_connection = response.data
      this.loading = false
      this.completeIntegrations = false
      this.editCredential = false
    },
    completeIntegration() {
      this.$refs.automapper.sendDataFinish()
    },
    copyButton() {
      this.copyAction = true
      this.$copyText(`${process.env.VUE_APP_URL_API}/api/2.0/projects/${this.accountSelect.project_id}/content/2.0/xml`)
      setTimeout(() => {
        this.copyAction = false
      }, 3000)
    },
    hasMultipleAccounts: function () {
      if (this.accounts.length > 1) {
        this.multiAccount = true
      }
    },
    async enableEdit() {
      this.loading = true
      let resChannelFrom = await axiosClient.get("api/2.0/channels", { params: { include: "services.service_config" } })
      let resChannelTo = await axiosClient.get("api/2.0/channels/2", { params: { include: ["services_output.service_config"] } })
      this.channelFrom = resChannelFrom.data.data.find((f) => f.data_json.driver == this.driver)
      this.channelTo = resChannelTo.data.data
      let filter = {}
      filter["filter[channel_id][=]"] = 2
      let resCredentialTo = await axiosClient.get(`api/2.0/project/${this.project_connection.project_id}/credentials`, { params: filter })
      this.projectCredentialTo = resCredentialTo.data.data[0]
      filter["filter[channel_id][=]"] = this.channelFrom.id
      let resCredentialFrom = await axiosClient.get(`api/2.0/project/${this.project_connection.project_id}/credentials`, { params: filter })
      this.projectCredentialFrom = resCredentialFrom.data.data[0]
      this.completeIntegrations = true
      this.editCredential = false
      this.loading = false
    },
    async reactiveIntegrations(){
      await axiosClient.get(`/api/2.0/account/reactive/integration`, {params: {project_connection_id: this.project_connection.id} })
      this.project_connection.is_active = true
      this.$toast.success(this.$t("mailupView.reactiveSuccess"))
    }
  },
  created() {
    this.accountSelect = this.accounts[0]
    axiosClient.defaults.headers["X-Tenant"] = this.accountSelect.tenant.uuid
    this.getIntegration()
    this.hasMultipleAccounts()
  }
}
</script>
